import { render, staticRenderFns } from "./SectionFeature.vue?vue&type=template&id=a5f9a2b2&scoped=true"
import script from "./SectionFeature.vue?vue&type=script&lang=js"
export * from "./SectionFeature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f9a2b2",
  null
  
)

export default component.exports